export const styles = {
    App: {
        flex: 1,
        textAlign: "center",
        display: "flex",
    },
    
    AppLogo: {
        height: 50,
        pointerEvents: "none",
        margin: "auto",
    },

    AboutMe: {
        margin: 30
    },

    aboutColumns: {
        display: "flex",
        flexWrap: "wrap",
        gap: 26,
        maxWidth: 720,
        margin: "20px auto",
        textAlign: "left",
        fontSize: 15,
        lineHeight: 1.6,
    },

    aboutColumn: {
        flex: 1,
        minWidth: 280,
    },

    profileLinks: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 10,
        marginTop: 18,
    },

    profileLink: {
        display: "inline-block",
        padding: "8px 18px",
        border: "1.5px solid #00ccff",
        borderRadius: 999,
        textDecoration: "none",
        fontSize: 14,
        fontWeight: 500,
        transition: "background-color 0.15s, color 0.15s",
    },

    CardGroup: {
        display: "flex",
        flex: 2,
        flexDirection: "column",
        maxHeight: 0
    },

    CardRow: {
        display: "flex",
        flex: 1,
        flexDirection: "row",
        justifyContent: "horizontal",
        alignItems: "center",
        objectFit: "contain",
    },

    CardStyle: {
        margin: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: 1,
        border: '2px solid #ccc',
        borderRadius: '5px',
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
        transition: 'transform 0.3s',
        transformStyle: 'preserve-3d',
        transform: 'rotateY(0deg)',
        cursor: 'pointer'
    },

    SelectedCardStyle: {
        margin: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: 1,
        border: '2px solid #33f',
        borderRadius: '5px',
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
        transition: 'transform 0.3s',
        transformStyle: 'preserve-3d',
        transform: 'rotateY(0deg)',
        cursor: 'pointer'
    },

    AppHeader: {
        display: "flex",
        backgroundColor: "#282c34",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "calc(10px + 2vmin)",
        color: "white",
    },
    
    AppLink: {
        color: "#61dafb",
    },

    Website: { 
        minHeight: "100vh",
        flex: 1,
        display: "flex",
        flexDirection: "column",
    },

    HeaderLink: {
        margin: "auto",
        flex: 1,
    },

    HeaderText: {
        fontSize: 30
    },

    Header: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#00ccff"
    },
    
    Game: {
        flex: 10,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 28,
        padding: 28,
        backgroundColor: "#f2fbff",
    },

    SetCard: {
        flex: 1
    },

    SetGame: {
        flex: 10,
        display: "flex",
        flexDirection: "row",
        gap: 28,
        padding: 28,
    },

    Body: {
        flex: 10
    },
    
    ControlPanel: {
        display: "flex",
        flex: "0 0 300px",
        flexDirection: "column",
        gap: 12,
        alignSelf: "stretch",
        justifyContent: "center",
    },

    playerXRadio: {
        flex: 1,
        textAlignVertical: "center"
    },

    setSide: {
        flex: 1
    },

    // The four control-panel sections share one card look.
    player1: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        backgroundColor: "#ffffff",
        border: "1px solid #cbecfa",
        borderRadius: 12,
        padding: "14px 16px",
    },
    
    player2: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        backgroundColor: "#ffffff",
        border: "1px solid #cbecfa",
        borderRadius: 12,
        padding: "14px 16px",
    },
    
    delay: {
        flex: 1,
        backgroundColor: "#c6f3ff",
    },
    
    intellimeter: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        backgroundColor: "#ffffff",
        border: "1px solid #cbecfa",
        borderRadius: 12,
        padding: "14px 16px",
    },
    
    range: {
        width: "100%",
    },
    
    stats: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        backgroundColor: "#ffffff",
        border: "1px solid #cbecfa",
        borderRadius: 12,
        padding: "14px 16px",
    },
    
    controlContent: {
        flex: 1,
        margin: "auto",
    },
    
    controlTitle: {
        margin: 0,
        fontSize: 17,
        fontWeight: 600,
        textAlign: "left",
        color: "#0a6f8f",
        letterSpacing: 0.2,
    },

    controlValue: {
        margin: 0,
        fontSize: 15,
        color: "#1c3f4d",
        textAlign: "left",
    },

    // Clickable label so the word next to a radio also selects it.
    radioRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 15,
        color: "#1c3f4d",
        cursor: "pointer",
    },

    statRow: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: 15,
        color: "#1c3f4d",
    },

    meterTrack: {
        width: "100%",
        height: 10,
        backgroundColor: "#e4f6fd",
        borderRadius: 999,
        overflow: "hidden",
    },

    meterFill: {
        height: "100%",
        backgroundColor: "#00b4e0",
        borderRadius: 999,
        transition: "width 0.3s",
    },

    resetButton: {
        marginTop: 4,
        padding: "8px 14px",
        fontSize: 14,
        fontWeight: 500,
        color: "#0a6f8f",
        backgroundColor: "#ffffff",
        border: "1.5px solid #00ccff",
        borderRadius: 999,
        cursor: "pointer",
        transition: "background-color 0.15s, color 0.15s",
    },
    
    p: {
        flex: 1,
        textAlign: "center",
        margin: 5,
        textAlignVertical: "center"
    },
    
    button: {
        margin: 30,
    },
    
    boxText: {
        margin: 0,
        fontSize: "clamp(34px, 9vmin, 76px)",
        lineHeight: 1,
        fontWeight: 700,
    },

    boxTextX: {
        color: "#e0483d",
    },

    boxTextO: {
        color: "#1f6feb",
    },
    
    // White cells on a solid cyan plate: the grid reads as lines between them.
    TicTacToe: {
        display: "flex",
        flexDirection: "column-reverse",
        flex: "1 1 auto",
        maxWidth: 520,
        aspectRatio: "1 / 1",
        alignSelf: "center",
        gap: 8,
        padding: 8,
        backgroundColor: "#00b4e0",
        borderRadius: 16,
        boxShadow: "0 10px 30px rgba(0, 90, 130, 0.18)",
    },
    
    row: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        gap: 8,
    },
    
    box: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        borderRadius: 10,
        cursor: "pointer",
        transition: "background-color 0.12s",
    }
};

// Layered on top of the matching `styles` entry when useIsMobile() is true.
export const mobileStyles = {
    // Nav wraps to a 2x2 grid instead of forcing the page wider than the screen.
    Header: {
        flex: "0 0 auto",
        flexWrap: "wrap",
    },

    HeaderButton: {
        flex: "1 1 45%",
        minWidth: 0,
        margin: 4,
        padding: "12px 4px",
    },

    HeaderText: {
        fontSize: 17,
        margin: 0,
    },

    AboutMe: {
        margin: 16,
    },

    // Board on top, controls underneath (column-reverse: the board is rendered second).
    Game: {
        flexDirection: "column-reverse",
        gap: 16,
        padding: 16,
        justifyContent: "flex-start",
    },

    TicTacToe: {
        flex: "0 0 auto",
        width: "100%",
        maxWidth: 440,
    },

    ControlPanel: {
        flex: "0 0 auto",
        width: "100%",
        maxWidth: 440,
        alignSelf: "center",
    },

    controlTitle: {
        fontSize: 16,
    },

    SetGame: {
        flexDirection: "column",
        gap: 16,
        padding: 16,
    },

    CardGroup: {
        maxHeight: "none",
        width: "100%",
    },

    setSide: {
        padding: "0 16px 24px",
    },
};
